import classNames from "classnames";
import MarkdownPreview, { MarkdownPreviewProps } from "@uiw/react-markdown-preview";

import styles from "./style.module.css";

export default function MarkdownPreviewCustom({ source, style, className, ...props }: MarkdownPreviewProps) {
  return (
    <div className={styles.wrapper}>
      <MarkdownPreview
        source={source}
        style={style}
        className={classNames(styles.markdownBaseView, className)}
        disableCopy={true}
        components={{
          input: ({ node, checked, ...props }) => {
            if (props.type === "radio" || props.type === "checkbox") {
              return <input {...props} defaultChecked={!!checked} checked={undefined} />;
            }
            return <input {...props} />;
          },
          a: ({ node, children, ...props }) => {
            // Require all links to open in a new tab
            return (
              <a target="_blank" {...props}>
                {children}
              </a>
            );
          },
        }}
        {...props}
      />
    </div>
  );
}
